export const fragenAutoUmschreibenBesitzUebertragen = [
  {
    question: "Was passiert, wenn der Käufer das Auto nicht umschreibt?",
    answer: (
      <>
        <p>
          Der alte Halter bleibt so lange verantwortlich, bis die Ummeldung
          erfolgt ist. Du kannst in diesem Fall selbst zur Zulassungsstelle
          gehen, um das Fahrzeug abzumelden. Dies schützt dich vor weiteren
          Verpflichtungen. Eventuell kann im Kaufvertrag eine Vertragsstrafe
          vereinbart werden, falls der Käufer die Frist nicht einhält.
        </p>
      </>
    ),
  },
  {
    question: "Kann ich das Auto vor dem Verkauf abmelden?",
    answer: (
      <>
        <p>
          Ja, du kannst dein Auto bereits abmelden und dann als abgemeldetes
          Fahrzeug übergeben. Der Käufer muss es allerdings dann mit roten
          Kennzeichen oder einem Anhänger transportieren. Viele Käufer
          bevorzugen ein angemeldetes Auto, weil eine Probefahrt möglich ist.
          Das bleibt deine Entscheidung.
        </p>
      </>
    ),
  },
  {
    question: "Brauche ich einen Kaufvertrag für eine Schenkung?",
    answer: (
      <>
        <p>
          Auch bei einer Schenkung empfiehlt sich ein schriftlicher Vertrag.
          Darin wird festgehalten, dass das Auto unentgeltlich übergeben wurde
          und der neue Halter ab sofort die Verantwortung trägt.
        </p>
      </>
    ),
  },
  {
    question: "Wie lange dauert die Umschreibung?",
    answer: (
      <>
        <p>
          Vor Ort dauert der Vorgang meist 20–30 Minuten, wenn alle Unterlagen
          vorliegen. Die Bearbeitungszeit variiert aber je nach Auslastung der
          Behörde.
        </p>
      </>
    ),
  },
];

